import Vue from 'vue'
import Router from 'vue-router'

import Top from '../components/top.vue'
import Home from '../components/home.vue'
import About from '../components/about.vue'
import Products from '../components/products.vue'
import Contact from '../components/contact.vue'
import Links from '../components/links.vue'

import Arduino from '../components/categorias/arduino.vue'
import Robotica from '../components/categorias/robotica.vue'
import Prototipagem from '../components/categorias/prototipagem.vue'
import Componentes from '../components/categorias/componentes.vue'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/home',
            name: 'top',
            component: Top,
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: Home
                },
                {
                    path: '/about',
                    name: 'about',
                    component: About
                },
                {
                    path: '/products',
                    name: 'products',
                    component: Products,
                    redirect: '/products/arduino',
                    children: [
                        {
                            path: 'arduino',
                            name: 'arduino',
                            component: Arduino 
                        },
                        {
                            path: 'robotica',
                            name: 'robotica',
                            component: Robotica 
                        },
                        {
                            path: 'Prototipagem',
                            name: 'prototipagem',
                            component: Prototipagem 
                        },
                        {
                            path: 'componentes',
                            name: 'componentes',
                            component: Componentes 
                        }
                    ]
                },
                {
                    path: '/contact',
                    name: 'contact',
                    component: Contact
                },
            ]
        },
        {
            path: '/links',
            name: 'links',
            component: Links                   
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});



// WEBPACK FOOTER //
// ./src/router/index.js